import {CodeName} from "../../stocks/models/code-name";

export class CompareItem extends CodeName {
    constructor(public readonly itemId: number,
        public readonly active: string,
        public readonly balanceStatus: number,
        code: any,
        name: string) {
        super(itemId, false, code, name);
    }

}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/compare-item.ts